export default {
  id: 55,
  title: 'Target #55 - Windmill',
  url: 'https://cssbattle.dev/play/55',
  colors: ['#191919', '#F9E492', '#4F77FF'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#191919}a{position:fixed;top:100;left:100;width:100;height:50;background:#F9E492;border-radius:50px 50px 0 0;transform-origin:100px 50px}a[b],a[d]{background:#4F77FF}a[b]{transform:rotate(90deg)}a[c]{transform:rotate(180deg)}a[d]{transform:rotate(270deg)}</style>',
}
